<div class="w-100 d-flex align-items-end justify-content-center mt-5">
    <p class="h3 text-center color-blue font-weight-bold customPage-heading">Payment Contacts</p>
</div>
<div class="container border mt-5">
    <div class="text-center  font-weight-bold info-heading" style="padding:16px 0px;">
        <span class="text-center pl-5">Paying to</span><span class="float-right"><a  routerLink="/create-contact"> <i class="fas fa-plus-circle mr-1"></i>Add</a></span>
    </div>
    <div class="row">
        <div class="col-12 col-lg-4" *ngFor="let contact of contacts">
                   <app-contact-card [contact]="contact"></app-contact-card>
          </div>
    </div>
</div>
